import React from 'react';
import { Link } from 'wouter';
import { Button } from "@/components/ui/button";
import { Home, ArrowLeft } from 'lucide-react';
import { SkipLink } from '@/components/ui/skip-link';

export default function NotFound() {
  return (
    <>
      <SkipLink href="#main-content">Skip to content</SkipLink>
      <div
        id="main-content"
        role="alert"
        className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-900"
      >
        <div className="text-center max-w-md mx-auto p-6">
          <div className="mb-8">
            <svg
              aria-hidden="true"
              className="mx-auto h-32 w-32 text-slate-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={0.5}
                d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>

          <h1 className="text-6xl font-bold text-slate-900 dark:text-white mb-4">404</h1>
          <h2 className="text-2xl font-semibold text-slate-700 dark:text-slate-300 mb-4">
            Page Not Found
          </h2>
          <p className="text-slate-600 dark:text-slate-400 mb-8">
            The page you're looking for doesn't exist or has been moved.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link href="/overview">
              <Button className="w-full sm:w-auto">
                <Home aria-hidden="true" className="w-4 h-4 mr-2" />
                Go to Dashboard
              </Button>
            </Link>
            <Button
              variant="outline"
              onClick={() => globalThis.history.back()}
              className="w-full sm:w-auto"
            >
              <ArrowLeft aria-hidden="true" className="w-4 h-4 mr-2" />
              Go Back
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
